import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMinusCircle = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm3.75 5.75a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h7.5z" />
    </g>
  );
};

export default withIcon(IconMinusCircle);
